import { render, staticRenderFns } from "./ToastNotifications.vue?vue&type=template&id=960845de&scoped=true&"
import script from "./ToastNotifications.vue?vue&type=script&lang=js&"
export * from "./ToastNotifications.vue?vue&type=script&lang=js&"
import style0 from "./ToastNotifications.vue?vue&type=style&index=0&id=960845de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960845de",
  null
  
)

export default component.exports